import { call, put, takeEvery } from 'redux-saga/effects';
import { getAdminDashboard } from '../../../api/dashboard/dashboardApi';
import {
  getAdminDashboardRequest,
  getAdminDashboardSuccess,
  getAdminDashboardFailure
} from '../../actions/dashboard/dashboardActions';

function* fetchAdminDashboardSaga(action) {
  try {
    yield put(getAdminDashboardRequest());
    const response = yield call(getAdminDashboard, action.payload.oemId, action.payload.scanType);
    yield put(getAdminDashboardSuccess(response));
  } catch (error) {
    yield put(getAdminDashboardFailure(error.response?.data?.message || error.message));
  }
}

function* dashboardSaga() {
  yield takeEvery('FETCH_ADMIN_DASHBOARD_SAGA', fetchAdminDashboardSaga);
}

export default dashboardSaga;